export function useRouterHelpers() {
  function getStartUrl(): string | undefined {
    let startURL;

    if (window.location.pathname !== '/') {
      startURL = window.location.pathname;
    }

    return startURL;
  }

  return { getStartUrl };
}
